module.exports = __webpack_public_path__ + "img/showImg2.4a7d8a07.png";